import { findDeepValue } from "./functions";

export function formatTripCounter(value) {
    return value === 316 || value === "316" ? "316 (Test Data)" : value;
}

export function findDeepDisplayValue(data, keys) {
    const value = findDeepValue(data, keys);
    return ["trip_counter", "tripCounter"].includes(keys?.[keys.length - 1])
        ? formatTripCounter(value)
        : value;
}
